























































import Vue from 'vue';

export default Vue.extend({
  props: {
    subtotal: {
      required: true,
    },
    discountAmount: {
      required: true,
    },
    discountPercent: {
      required: true,
    },
    shippingDollarAmount: {
      required: true,
    },
    taxAmount: {
      required: true,
    },
    taxPercent: {
      required: true,
    },
    initialDiscountState: {
      required: true,
      type: Boolean,
    },
    initialTaxState: {
      required: true,
      type: Boolean,
    },
    initialShippingState: {
      required: true,
      type: Boolean,
    },
    total: {
      required: true,
    },
  },
});

